const ActionTypes = {
  ADD_IMAGES: 'ADD_IMAGES',
  ADD_IMAGE: 'ADD_IMAGE',
  ADD_UPLOADED_IMAGE: 'ADD_UPLOADED_IMAGE',
  ADD_UPLOADING_IMAGES: 'ADD_UPLOADING_IMAGES',
  ADD_PROCESSING_IMAGE: 'ADD_PROCESSING_IMAGE',
  ADD_PROCESSED_IMAGE: 'ADD_PROCESSED_IMAGE',
  UPDATE_OBJECT_COUNT: 'UPDATE_OBJECT_COUNT',
  DELETE_UPLOADED_IMAGE: 'DELETE_UPLOADED_IMAGE',
  DELETE_IMAGE: 'DELETE_IMAGE',
};

module.exports = {
  ActionTypes,
};
